import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsWebDev() {
  const descriptionList = [
    "Vous souhaitez une présence en ligne professionnelle pour présenter votre activité ? Nous vous proposons de developper un site vitrine sur-mesure, adapté à vos besoins et à votre image.",
    "Le site peut comporter plusieurs pages, avec des fonctionnalités spécifiques selon votre projet.",
    "Hébergement et nom de domaine disponibles en option pour une gestion simplifiée.",
  ];
  const deroulementList = [
    "1 Premier entretien (gratuit) - Définition du projet Discussion sur vos besoins : nombre de pages, fonctionnalités spécifiques, objectifs du site. Établissement d’un devis détaillé selon la complexité du projet.",
    "2 Deuxième rendez-vous – Charte graphique et design (optionnel : 250€ TTC) Rencontre avec un designer web partenaire pour définir une charte graphique professionnelle. Création de visuels et d'exemples pour valider le style du site.",
    "3 Développement du site : Développement du site selon les maquettes validées. Échanges réguliers pour assurer un suivi optimum. Tests et ajustements avant la mise en ligne.",
    "4 Livraison et mise en ligne : Remise du code source complet du site. Installation et mise en ligne si vous avez souscrit à l’hébergement. Explication sur la gestion du site et son utilisation.",
    "(Optionnel) Hébergement et nom de domaine (20€/mois) : Gestion du nom de domaine et de l’hébergement.Maintenance technique et mises à jour.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="DÉVELOPPEMENT DE SITE WEB"
        price="250€ + ~300€ par page (selon complexité déterminée lors du devis)."
        atelier={true}
        domicile={false}
        time="1 à 2 mois"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="Si vous souhaitez effectuer des modifications ponctuelles sur votre site web, nous pouvons établir un devis gratuitement. Si votre activité nécessite des mises à jour régulières, nous pouvons vous proposer un forfait spécial." />
    </div>
  );
}

export default TarifsWebDev;
